import React from 'react';
import handleProviderProvider from 'mn-utils/changeProviderProviderSimple';
import withState from '../../../../utils/withState';
import Caption from '../../../dumb/Caption/B';
import Password from './components/Password/';
import Tfa from './components/Tfa/';


module.exports = withState((setState) => {
  const handleProvider = handleProviderProvider(setState);
  const handleChangeStatePassword = handleProvider('statePassword');

  return (state) => {
    return (
      <div>
        <Caption
          data-testid="titleChangePwd"
        >
          Change Password
        </Caption>
        <Password
          className="mt35"
          onChange={handleChangeStatePassword}
        />
        <div className="h1 mt56 mb40 bgDADCE1"/>
        <Caption
          data-testid="titleChange2FA"
        >
          Two Factor Authorization
        </Caption>
        <div className="mt35">
          <Tfa />
        </div>
        <div className="h1 mt56 mb40 bgDADCE1"/>
      </div>
    );
  };
});
